// components/AuthListener.tsx
"use client";

import { useEffect } from "react";
import { useRouter, usePathname } from "next/navigation";
import { useLogout } from "@/apiUtilities/mutations/useLogout";
import { useTransitionRouter } from "next-view-transitions";


export function CompleteAccountListener() {
  const router = useTransitionRouter();
  const pathname = usePathname();

  useEffect(() => {
    const handler = () => {
      // Solo hacer push si no estamos ya en complete-account
      if (!pathname.includes('/complete-account')) {
        router.push('/complete-account')
      }
    };

    window.addEventListener("complete_account_required", handler);

    return () => {
      window.removeEventListener("complete_account_required", handler);
    };
  }, [router, pathname]);

  return null
}